import { useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Ruler } from "lucide-react";
import api from "@/lib/api";

// Rohr fotografieren → KI liest Durchmesser + Material → Vorschlag an der Karte.
export default function PipeMeasureButton({ projectId, group, onDone }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);

  const run = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const up = await api.post(`/projects/${projectId}/vcheck-wp/photos/photos_pipe_dimension/upload`, form,
                                { headers: { "Content-Type": "multipart/form-data" } });
      const r = await api.post(`/projects/${projectId}/vcheck-wp/ai/pipe`, { photo_id: up.data.photo.id, group });
      const n = Object.keys(r.data?.suggestions || {}).length;
      if (n) toast.success(`KI-Vorschlag für ${group} bereit – bitte prüfen`);
      else toast.info("KI konnte auf dem Foto nichts sicher erkennen");
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "KI-Messung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy}
              data-testid={`wizard-pipe-ai-${group}`}
              className="h-9 px-3 rounded-lg bg-amber-400/15 border border-amber-400/40 text-amber-200 text-[12.5px] font-semibold inline-flex items-center gap-1.5 disabled:opacity-50">
        {busy ? <Loader2 size={13} className="animate-spin" /> : <Ruler size={13} />}
        {busy ? "KI misst …" : "Foto messen (KI)"}
      </button>
      <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden"
             onChange={(e) => { run(e.target.files?.[0]); e.target.value = ""; }} />
    </>
  );
}
